import { Component, Input, Self, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { EmailEnrollResponse, SmsEnrollResponse } from '../../app.actions';
import { STATE_TOKEN, StateModel } from '../../app.states';
import { EmailVerifyPopupComponent } from '../email-verify-popup/email-verify-popup.component';
import { SmsVerifyPopupComponent } from '../sms-verify-popup/sms-verify-popup.component';
import { OktaFactorService } from 'apps/app-cic-ciam/src/services/oktafactor.service';
import { SelfFactorService } from 'apps/app-cic-ciam/src/services/selffactor.service';
import { SmsCodeMode } from '../../widgets/sms-code/sms-code.component';
import { EmailCodeMode } from '../../widgets/email-code/email-code.component';
import { phoneNumberWrapping } from '../../functions/utils';

@Component({
  selector: 'ciciam-change-2fa-popup',
  templateUrl: './change-2fa-popup.component.html',
  styleUrls: ['./change-2fa-popup.component.scss'],
})
export class Change2faPopupComponent {
  showModal = false;

  courseId: string = '';
  courseName: string = '';
  coursePrice: number = 0;
  isChanged: boolean = false;
  verifyOnly = false;
  onDismiss?: (factor?: any) => Promise<any> = undefined;
  @Select(STATE_TOKEN) appState$!: Observable<StateModel>;
  @Input() smsMode: SmsCodeMode = SmsCodeMode.USER_UPDATE_2FA;
  @Input() emailMode: EmailCodeMode = EmailCodeMode.USER_UPDATE_2FA;
  // userId?: string;

  sms2faData: any;
  email2faData: any;

  emailForm = this.fb.group({
    emailEnable: [false],
    email: [
      '',
      [
        Validators.required,
        Validators.pattern(
          /(?:[a-z0-9!#$%&*+/=?^_{|}-]+(?:\.[a-z0-9!#$%&*+/=?^_{|}-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]?[a-z0-9])+|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        ),
      ],
    ],
  });
  phoneForm = this.fb.group({
    phoneNumberEnable: [false],
    phoneNumber: [
      '',
      [Validators.required, Validators.pattern('^(\\+[0-9]+|[0-9]{8,})$')],
    ],
  });

  get emailFormValues() {
    return this.emailForm.getRawValue();
  }
  get phoneFormValues() {
    return this.phoneForm.getRawValue();
  }
  emailFormInitValue: any;
  phoneFormInitValue: any;

  isLoading = false;

  enabledButtonClasses = [
    'bg-notus-primary-600',
    'hover:bg-notus-primary-700',
    'focus:ring-notus-primary-300',
    'dark:bg-primary-600',
    'dark:hover:bg-primary-700',
    'dark:focus:ring-primary-800',
  ];

  disabledButtonClasses = ['cursor-not-allowed', 'bg-notus-primary-300'];

  @ViewChild('smsPopup') public smsPopup!: SmsVerifyPopupComponent;
  @ViewChild('emailPopup') public emailPopup!: EmailVerifyPopupComponent;

  method: string = '';
  haveOtherTwofa: boolean = false;
  otherTwofaData?: any;
  isVerificationNeeded = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private supportService: SupportService,
    private oktaFactorService: OktaFactorService,
    private selfFactorService: SelfFactorService,
    private store: Store,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // this.appState$.subscribe((state) => {
    //   this.userId = state.userId;
    // });

    // Strip non-digit characters from phone number input as the user types
    this.phoneForm.get('phoneNumber')?.valueChanges.subscribe((value) => {
      if (value) {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned !== value) {
          this.phoneForm.get('phoneNumber')?.setValue(cleaned, { emitEvent: false });
        }
      }
    });
  }

  requestPrompt(
    method: string,
    twofaData: any,
    contact: string,
    haveOtherTwofa: boolean,
    otherTwofaData?: any,
    onDismiss?: (factor?: any) => Promise<any>,
    verifyOnly: boolean = false
  ) {
    this.method = method;
    this.haveOtherTwofa = haveOtherTwofa;
    this.otherTwofaData = otherTwofaData;
    this.isVerificationNeeded = twofaData && twofaData.status != 'ACTIVE';
    this.onDismiss = onDismiss;
    this.isChanged = false;
    this.verifyOnly = verifyOnly;

    console.log(`this.verifyOnly: ${this.verifyOnly}`);

    switch (this.method) {
      case 'sms':
        this.sms2faData = twofaData;
        if (this.sms2faData && this.sms2faData.profile.phoneNumber) {
          this.phoneForm.controls.phoneNumber.enable();
          this.phoneFormInitValue = {
            phoneNumberEnable: true,
            phoneNumber: this.sms2faData.profile.phoneNumber.replace(
              '+852',
              ''
            ),
          };
        } else {
          this.phoneForm.controls.phoneNumber.disable();
          this.phoneFormInitValue = {
            phoneNumberEnable: false,
            phoneNumber: '',
          };
        }
        this.phoneForm.setValue(this.phoneFormInitValue);
        break;
      case 'email':
        this.email2faData = twofaData;
        if (this.email2faData && this.email2faData.profile.email) {
          this.emailForm.controls.email.enable();
          this.emailFormInitValue = {
            emailEnable: true,
            email: this.email2faData.profile.email,
          };
        } else {
          this.emailForm.controls.email.disable();
          this.emailFormInitValue = {
            emailEnable: false,
            email: '',
          };
        }
        this.emailForm.setValue(this.emailFormInitValue);
        break;
    }

    if (verifyOnly) {
      switch (this.method) {
        case 'sms':
          this.phoneForm.controls.phoneNumberEnable.setValue(true);

          if ((this.phoneForm.controls.phoneNumber?.value ?? '') != '') {
            // this.phoneForm.disable();

            var validRegex = /^(\+[0-9]+|[0-9]{8,})$/;
            if (
              !(
                this.phoneForm.controls.phoneNumber.value?.match(validRegex) ??
                false
              )
            ) {
              this.phoneForm.controls.phoneNumber.setErrors({
                phoneformat: 'regerror.phoneformat',
              });

              this.phoneForm.controls.phoneNumber.enable();
            } else {
              this.phoneForm.controls.phoneNumber.disable();
            }
          } else {
            this.phoneForm.controls.phoneNumber.enable();
          }

          this.phoneForm.controls.phoneNumberEnable.disable();

          break;
        case 'email':
          this.emailForm.controls.emailEnable.setValue(true);

          if ((this.emailForm.controls.email?.value ?? '') != '') {
            // this.emailForm.disable();

            var validRegex =
              /(?:[a-z0-9!#$%&*+/=?^_{|}-]+(?:\.[a-z0-9!#$%&*+/=?^_{|}-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]?[a-z0-9])+|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
            if (
              !(this.emailForm.controls.email.value!.match(validRegex) ?? false)
            ) {
              this.emailForm.controls.email.setErrors({
                emailformat: 'regerror.emailformat',
              });

              this.emailForm.controls.email.enable();
            } else {
              this.emailForm.controls.email.disable();
            }
          } else {
            this.emailForm.controls.email.enable();
          }

          this.emailForm.controls.emailEnable.disable();

          break;
        default:
          break;
      }
    }

    this.showModal = true;
  }

  onEmailEnableToggle($event: any) {
    if (!this.emailFormValues.emailEnable) {
      this.emailForm.controls.email.enable();
      this.emailForm.controls.email.setValidators([Validators.required]);
    } else {
      this.emailForm.controls.email.disable();
      this.emailForm.controls.email.setValidators([]);
    }
    this.emailForm.controls.email.updateValueAndValidity();
  }

  onSmsEnableToggle($event: any) {
    if (!this.phoneFormValues.phoneNumberEnable) {
      this.phoneForm.controls.phoneNumber.enable();
      this.phoneForm.controls.phoneNumber.setValidators([Validators.required]);
    } else {
      this.phoneForm.controls.phoneNumber.disable();
      this.phoneForm.controls.phoneNumber.setValidators([]);
    }
    this.phoneForm.controls.phoneNumber.updateValueAndValidity();
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  async onEmailFormSubmit() {
    const enable2fa = this.emailForm.getRawValue().emailEnable;

    if (this.emailForm.valid || this.verifyOnly) {
      if (!enable2fa) {
        if (!this.haveOtherTwofa) {
          this.toastr.error(
            this.translate.instant(
              'At least one Two-factor Authentication method has to be enabled'
            ),
            this.translate.instant('Error')
          );
          return;
        }
        if (confirm(this.translate.instant('change2fa.confirmDisableEmail'))) {
          this.onRemoveEmail(undefined);
        } else {
        }
      } else {
        // var myacc = this.oktaAuth.myaccount;
        // myacc.addEmail({
        //   profile:{
        //     email: this.emailForm.value.email,
        //   },
        //   sendEmail: true,
        //   role: "PRIMARY"
        // });
        // return;

        this.isLoading = true;
        try {
          let result = await this.selfFactorService.selfSend2faEmail(
            true,
            this.emailForm.value.email ?? undefined
          );
          this.isLoading = false;
          if (!result || result.success == false) {
            this.emailForm.controls.email.setErrors({
              emailused: 'emailused',
            });
          } else {
            this.store.dispatch(new EmailEnrollResponse(result));
            this.isChanged = true;
            this.emailPopup.requestPrompt(async () => {
              this.toggleModal();
              this.onDismiss?.(result.email ?? this.emailForm.value.email);
            });
          }
        } catch (e: any) {
          console.log(e);
          this.isLoading = false;
          if (e?.status === 429) {
            this.toastr.error(
              this.translate.instant('Too many attempts. Please try again in a minute.'),
              this.translate.instant('Error')
            );
          } else {
            this.emailForm.controls.email.setErrors({ pattern: 'pattern' });
          }
        }

        // let result = await this.supportService.changePassword(this.userId!, this.FormValues.current_password, this.FormValues.new_password);

        // if(result.errorCode) {
        //   this.toastr.error('Password change failed:</br>' + result.errorCauses.map((c: { errorSummary: any; }) => '- ' + c.errorSummary).join('</br>'), 'Error', {
        //     enableHtml: true,
        //   });
        // } else {
        //   this.toastr.success('Password changed successfully', 'Success');
        //   this.toggleModal();
        // }
      }
    }
  }

  async onPhoneFormSubmit() {
    const enable2fa = this.phoneForm.getRawValue().phoneNumberEnable;

    if (enable2fa && (this.phoneForm.controls.phoneNumber?.value ?? '') != '') {
      var validRegex = /^(\+[0-9]+|[0-9]{8,})$/;
      if (!this.phoneForm.controls.phoneNumber.value!.match(validRegex)) {
        this.phoneForm.controls.phoneNumber.setErrors({
          phoneformat: 'regerror.phoneformat',
        });
      }
    }

    if (this.phoneForm.valid || this.verifyOnly) {
      if (!enable2fa) {
        if (!this.haveOtherTwofa) {
          this.toastr.error(
            this.translate.instant(
              'At least one Two-factor Authentication method has to be enabled'
            ),
            this.translate.instant('Error')
          );
          return;
        }
        if (confirm(this.translate.instant('change2fa.confirmDisableSms'))) {
          this.onRemoveSms(undefined);
        } else {
        }
      } else {
        this.isLoading = true;
        try {
          let result = await this.selfFactorService.selfSend2faSms(
            true,
            phoneNumberWrapping(this.phoneForm.value.phoneNumber ?? '')
          );
          this.isLoading = false;
          if (!result || result.success == false) {
            this.phoneForm.controls.phoneNumber.setErrors({
              phoneused: 'phoneused',
            });
          } else {
            this.isChanged = true;
            this.store.dispatch(new SmsEnrollResponse(result));
            this.isChanged = true;
            this.smsPopup.requestPrompt(async () => {
              this.toggleModal();
              this.onDismiss?.(
                result.phoneNumber ??
                  phoneNumberWrapping(this.phoneForm.value.phoneNumber ?? '')
              );
            });
          }
        } catch (e: any) {
          this.isLoading = false;
          if (e?.status === 429) {
            this.toastr.error(
              this.translate.instant('Too many attempts. Please try again in a minute.'),
              this.translate.instant('Error')
            );
          } else {
            this.phoneForm.controls.phoneNumber.setErrors({
              pattern: 'pattern',
            });
          }
        }
      }
    }
  }

  async onRemoveEmail($event: any) {
    if ($event) $event.preventDefault();
    if (!this.haveOtherTwofa) {
      this.toastr.error(
        this.translate.instant(
          'At least one Two-factor Authentication method has to be enabled'
        ),
        this.translate.instant('Error')
      );
      return;
    }
    this.isLoading = true;
    console.log(this.otherTwofaData);
    await this.oktaFactorService.removeEmail2fa();
    this.toastr.success(
      this.translate.instant('Email Authentication removed successfully'),
      this.translate.instant('Success')
    );
    this.isLoading = false;
    this.toggleModal();
    this.onDismiss?.();
  }

  async onRemoveSms($event: any) {
    if ($event) $event.preventDefault();
    if (!this.haveOtherTwofa) {
      this.toastr.error(
        this.translate.instant(
          'At least one Two-factor Authentication method has to be enabled'
        ),
        this.translate.instant('Error')
      );
      return;
    }
    this.isLoading = true;
    await this.oktaFactorService.removeSms2fa();
    this.toastr.success(
      this.translate.instant('SMS Authentication removed successfully'),
      this.translate.instant('Success')
    );
    this.isLoading = false;
    this.toggleModal();
    this.onDismiss?.();
  }

  onCancel($event: any) {
    $event.preventDefault();
    if (this.isChanged) {
      this.onDismiss?.();
    }
    this.toggleModal();
  }

  get isFormModified(): boolean {
    if (this.verifyOnly) {
      return true;
    }

    switch (this.method) {
      case 'sms':
        return (
          this.phoneForm.value.phoneNumberEnable !=
            this.phoneFormInitValue.phoneNumberEnable ||
          this.phoneForm.value.phoneNumber !=
            this.phoneFormInitValue.phoneNumber
        );
      case 'email':
        return (
          this.emailForm.value.emailEnable !=
            this.emailFormInitValue.emailEnable ||
          this.emailForm.value.email != this.emailFormInitValue.email
        );
    }

    return false;
  }
}
